export default __webpack_public_path__ + "static/app-3-0cac07287999fb862a0691de6b02a915.webp";